export enum EDPadButtonMode {
    Directional,
    Rotational,
}